import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const TRADE_TYPE = {
  AGRI_INPUT_MARKET: 0,
  CROP_MARKET: 1
}

export const TRADE_TYPE_MAP = {
  0: t('constants.trade_type.agri_input_market'),
  1: t('constants.trade_type.crop_market')
}

export const TRADE_TYPE_DATA = [
  { id: 0, name: t('constants.trade_type.agri_input_market') },
  { id: 1, name: t('constants.trade_type.crop_market') }
]
